/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _h1_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Contactez Go Africa Online, l'ensemble de nos bureaux locaux sont à votre service",
        },
    ],
    'fr',
);

const _h1_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Contact Go Africa Online, all our local offices are at your service',
        },
    ],
    'en',
);

export function h1(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _h1_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _h1_en.format(args) as unknown as string;
    }

    return _h1_fr.format(args) as unknown as string;
}

const _subtitle_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Vous avez besoin d'une information ou d'une demande de rendez-vous, utilisez le formulaire de contact ou appelez directement nos équipes locales.",
        },
    ],
    'fr',
);

const _subtitle_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'If you need information or want to request an appointment, use the contact form or call our local teams directly.',
        },
    ],
    'en',
);

export function subtitle(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _subtitle_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _subtitle_en.format(args) as unknown as string;
    }

    return _subtitle_fr.format(args) as unknown as string;
}

const _contact_general_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Contact général' }],
    'fr',
);

const _contact_general_en = new IntlMessageFormat(
    [{ type: 0, value: 'General Contact' }],
    'en',
);

export function contact_general(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_general_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_general_en.format(args) as unknown as string;
    }

    return _contact_general_fr.format(args) as unknown as string;
}

const _contact_administration_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Direction' }],
    'fr',
);

const _contact_administration_en = new IntlMessageFormat(
    [{ type: 0, value: 'Management' }],
    'en',
);

export function contact_administration(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_administration_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_administration_en.format(args) as unknown as string;
    }

    return _contact_administration_fr.format(args) as unknown as string;
}

const _contact_public_relations_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Relation presse' }],
    'fr',
);

const _contact_public_relations_en = new IntlMessageFormat(
    [{ type: 0, value: 'Press Relations' }],
    'en',
);

export function contact_public_relations(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_public_relations_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_public_relations_en.format(args) as unknown as string;
    }

    return _contact_public_relations_fr.format(args) as unknown as string;
}

const _contact_yellow_pages_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Annuaire pro' }],
    'fr',
);

const _contact_yellow_pages_en = new IntlMessageFormat(
    [{ type: 0, value: 'Business Directory' }],
    'en',
);

export function contact_yellow_pages(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_yellow_pages_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_yellow_pages_en.format(args) as unknown as string;
    }

    return _contact_yellow_pages_fr.format(args) as unknown as string;
}

const _contact_website_creation_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Création de site' }],
    'fr',
);

const _contact_website_creation_en = new IntlMessageFormat(
    [{ type: 0, value: 'Website Creation' }],
    'en',
);

export function contact_website_creation(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_website_creation_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_website_creation_en.format(args) as unknown as string;
    }

    return _contact_website_creation_fr.format(args) as unknown as string;
}

const _our_offices_fr = new IntlMessageFormat([{ type: 0, value: 'Nos bureaux' }], 'fr');

const _our_offices_en = new IntlMessageFormat([{ type: 0, value: 'Our Offices' }], 'en');

export function our_offices(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _our_offices_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _our_offices_en.format(args) as unknown as string;
    }

    return _our_offices_fr.format(args) as unknown as string;
}

const _contact_information_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Informations de contact' }],
    'fr',
);

const _contact_information_en = new IntlMessageFormat(
    [{ type: 0, value: 'Contact Information' }],
    'en',
);

export function contact_information(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_information_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_information_en.format(args) as unknown as string;
    }

    return _contact_information_fr.format(args) as unknown as string;
}

const _contact_toast_success_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Votre demande a bien été envoyée,\nNous vous en remercions et vous contactons dans les plus brefs délais.',
        },
    ],
    'fr',
);

const _contact_toast_success_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Your request has been sent successfully.\nThank you, we will contact you as soon as possible.',
        },
    ],
    'en',
);

export function contact_toast_success(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_toast_success_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_toast_success_en.format(args) as unknown as string;
    }

    return _contact_toast_success_fr.format(args) as unknown as string;
}

const _option__to_general_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Contact général' }],
    'fr',
);

const _option__to_general_en = new IntlMessageFormat(
    [{ type: 0, value: 'General Contact' }],
    'en',
);

export function option__to_general(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _option__to_general_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _option__to_general_en.format(args) as unknown as string;
    }

    return _option__to_general_fr.format(args) as unknown as string;
}

const _option__to_administration_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Direction' }],
    'fr',
);

const _option__to_administration_en = new IntlMessageFormat(
    [{ type: 0, value: 'Management' }],
    'en',
);

export function option__to_administration(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _option__to_administration_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _option__to_administration_en.format(args) as unknown as string;
    }

    return _option__to_administration_fr.format(args) as unknown as string;
}

const _option__to_public_relations_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Relations presse' }],
    'fr',
);

const _option__to_public_relations_en = new IntlMessageFormat(
    [{ type: 0, value: 'Press Relations' }],
    'en',
);

export function option__to_public_relations(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _option__to_public_relations_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _option__to_public_relations_en.format(args) as unknown as string;
    }

    return _option__to_public_relations_fr.format(args) as unknown as string;
}

const _option__to_yellow_pages_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Annuaire pro' }],
    'fr',
);

const _option__to_yellow_pages_en = new IntlMessageFormat(
    [{ type: 0, value: 'Business Directory' }],
    'en',
);

export function option__to_yellow_pages(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _option__to_yellow_pages_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _option__to_yellow_pages_en.format(args) as unknown as string;
    }

    return _option__to_yellow_pages_fr.format(args) as unknown as string;
}

const _option__to_web_creation_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Création de sites' }],
    'fr',
);

const _option__to_web_creation_en = new IntlMessageFormat(
    [{ type: 0, value: 'Website Creation' }],
    'en',
);

export function option__to_web_creation(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _option__to_web_creation_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _option__to_web_creation_en.format(args) as unknown as string;
    }

    return _option__to_web_creation_fr.format(args) as unknown as string;
}

const _option__subject_appointment_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Demande de rendez-vous' }],
    'fr',
);

const _option__subject_appointment_en = new IntlMessageFormat(
    [{ type: 0, value: 'Appointment Request' }],
    'en',
);

export function option__subject_appointment(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _option__subject_appointment_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _option__subject_appointment_en.format(args) as unknown as string;
    }

    return _option__subject_appointment_fr.format(args) as unknown as string;
}

const _option__subject_information_fr = new IntlMessageFormat(
    [{ type: 0, value: "Demande d'information" }],
    'fr',
);

const _option__subject_information_en = new IntlMessageFormat(
    [{ type: 0, value: 'Information Request' }],
    'en',
);

export function option__subject_information(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _option__subject_information_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _option__subject_information_en.format(args) as unknown as string;
    }

    return _option__subject_information_fr.format(args) as unknown as string;
}

const _label_to_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Message adressé à' }],
    'fr',
);

const _label_to_en = new IntlMessageFormat(
    [{ type: 0, value: 'Message addressed to' }],
    'en',
);

export function label_to(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_to_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_to_en.format(args) as unknown as string;
    }

    return _label_to_fr.format(args) as unknown as string;
}

const _placeholder_select_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Choisissez' }],
    'fr',
);

const _placeholder_select_en = new IntlMessageFormat(
    [{ type: 0, value: 'Choose' }],
    'en',
);

export function placeholder_select(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _placeholder_select_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _placeholder_select_en.format(args) as unknown as string;
    }

    return _placeholder_select_fr.format(args) as unknown as string;
}

const _label_subject_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Sujet du message' }],
    'fr',
);

const _label_subject_en = new IntlMessageFormat(
    [{ type: 0, value: 'Message subject' }],
    'en',
);

export function label_subject(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_subject_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_subject_en.format(args) as unknown as string;
    }

    return _label_subject_fr.format(args) as unknown as string;
}

const _label_firstname_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Votre prénom' }],
    'fr',
);

const _label_firstname_en = new IntlMessageFormat(
    [{ type: 0, value: 'Your first name' }],
    'en',
);

export function label_firstname(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_firstname_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_firstname_en.format(args) as unknown as string;
    }

    return _label_firstname_fr.format(args) as unknown as string;
}

const _label_lastname_fr = new IntlMessageFormat([{ type: 0, value: 'Votre nom' }], 'fr');

const _label_lastname_en = new IntlMessageFormat(
    [{ type: 0, value: 'Your last name' }],
    'en',
);

export function label_lastname(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_lastname_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_lastname_en.format(args) as unknown as string;
    }

    return _label_lastname_fr.format(args) as unknown as string;
}

const _label_email_fr = new IntlMessageFormat([{ type: 0, value: 'Votre email' }], 'fr');

const _label_email_en = new IntlMessageFormat([{ type: 0, value: 'Your email' }], 'en');

export function label_email(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_email_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_email_en.format(args) as unknown as string;
    }

    return _label_email_fr.format(args) as unknown as string;
}

const _label_phone_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Votre téléphone' }],
    'fr',
);

const _label_phone_en = new IntlMessageFormat(
    [{ type: 0, value: 'Your phone number' }],
    'en',
);

export function label_phone(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_phone_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_phone_en.format(args) as unknown as string;
    }

    return _label_phone_fr.format(args) as unknown as string;
}

const _label_companyName_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nom de votre société' }],
    'fr',
);

const _label_companyName_en = new IntlMessageFormat(
    [{ type: 0, value: 'Your company name' }],
    'en',
);

export function label_companyName(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_companyName_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_companyName_en.format(args) as unknown as string;
    }

    return _label_companyName_fr.format(args) as unknown as string;
}

const _label_message_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Votre message' }],
    'fr',
);

const _label_message_en = new IntlMessageFormat(
    [{ type: 0, value: 'Your message' }],
    'en',
);

export function label_message(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_message_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_message_en.format(args) as unknown as string;
    }

    return _label_message_fr.format(args) as unknown as string;
}
